import React from 'react';

const Feedback = ({ className = '' }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.6665 6.33334C12.6683 7.2132 12.4627 8.08109 12.0665 8.86668C11.5961 9.80784 10.873 10.5995 9.97814 11.1529C9.08327 11.7063 8.052 11.9996 6.99984 12C6.11998 12.0018 5.25209 11.7962 4.4665 11.4L0.666504 12.6667L1.93317 8.86668C1.53693 8.08109 1.33138 7.2132 1.33317 6.33334C1.33358 5.28118 1.62691 4.24991 2.18032 3.35504C2.73372 2.46018 3.52534 1.73706 4.4665 1.26668C5.25209 0.87044 6.11998 0.664886 6.99984 0.666678H7.33317C8.72274 0.743339 10.0352 1.32985 11.0193 2.31392C12.0033 3.29798 12.5898 4.61045 12.6665 6.00001V6.33334Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Feedback;
